import React from 'react';
import { Box, Button, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import MText from '../../components/common/MText';

function TabContent(props) {
  const { name, title, content, imgSrc, index, button, link, ...other } = props;
  console.log(`imgSrc${imgSrc}`);
  return (
    <div role="tabpanel" id={`simple-tabpanel-${index}`} {...other}>
      <Box sx={{ p: 3 }}>
        <TabPanelbox>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
            <h4 style={{ color: '#2065D1', marginBottom: '40px' }}>{name}</h4>
            <h2 style={{ marginBottom: '20px' }}>{title}</h2>
            <MText>{content}</MText>
            <TabPanelButton href={link} variant="contained">
              {button}
            </TabPanelButton>
          </div>

          <div>
            <img src={imgSrc} alt="imgSrc" />
          </div>
        </TabPanelbox>
      </Box>
    </div>
  );
}

const TabPanelbox = styled(Box)({
  textAlign: 'center',
  flexDirection: 'row',
  justifyContent: 'space-between',
  display: 'flex',
  padding: '100px 10%',
  alignItems: 'center',
});

const TabPanelButton = styled(Button)({
  fontFamily: 'Pretendard-Regular',
  fontSize: '1.2rem',
  padding: '1rem 2rem',
  marginTop: '60px',
});

export default TabContent;
